import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
// import { USER_MGMT_CNST } from 'usermgmt';
import { isEmptyField, isNullOrUndefined } from '../vl_util_functions/common-utils';
@Injectable({
  providedIn: 'root'
})
export class VlDataService {

  constructor(
    private toastr: ToastrService
  ) { }

  // showToastMessage(message: string, type: string, options?: any): void {
  //   let toastOptions: any = USER_MGMT_CNST.TOASTR_CNST;
  //   if (!isNullOrUndefined(options)) {
  //     toastOptions = { ...USER_MGMT_CNST.TOASTR_CNST, ...options.options };
  //   }
  //   this.toastr.clear();
  //   (this.toastr[type as keyof typeof this.toastr] as any)(message, toastOptions.title, toastOptions);
  // }

  deepMerge(src: any, dest: any, options?: any): any {
    const result: any = {};
    // tslint:disable-next-line: forin
    for (const i in src) {
      const type = typeof src[i];
      if (!isNullOrUndefined(options) && !isNullOrUndefined(options.customMerge) && !isNullOrUndefined(options.customMerge[i])) {

        // tslint:disable-next-line: triple-equals
        if (options.customMerge[i] == 'dest') {
          result[i] = !isNullOrUndefined(dest[i]) ? dest[i] : null;
          // tslint:disable-next-line: triple-equals
        } else if (options.customMerge[i] == 'src') {
          result[i] = !isNullOrUndefined(src[i]) ? src[i] : null;
        } else {
          result[i] = options.customMerge[i](src[i], dest[i]);
        }
      } else if (!isNullOrUndefined(src) && src[i] !== null && type == 'object' && !(src[i] instanceof Array)) {
        result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? this.deepMerge(src[i], dest[i], options) : src[i];
      } else if (!isNullOrUndefined(src) && !isNullOrUndefined(src[i]) && src[i] instanceof Array) {
        if (!isNullOrUndefined(options) && !isNullOrUndefined(options.array) && options.array == 'merge') {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i]) && dest[i].length > 0) ? src[i].concat(dest[i]) : src[i];
        } else if (!isNullOrUndefined(options) && !isNullOrUndefined(options.array) && options.array == 'override') {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? dest[i] : src[i];
        } else {
          result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i]) && dest[i].length > 0) ? src[i].concat(dest[i]) : src[i];
        }
      } else {
        result[i] = (!isNullOrUndefined(dest) && !isNullOrUndefined(dest[i])) ? dest[i] : src[i];
      }
    }
    for (const i in dest) {
      if (isNullOrUndefined(result[i])) {
        result[i] = dest[i];
      }
    }
    return result;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  deepCompare(obj1: any, obj2: any) {
    // Loop through properties in object 1
    // tslint:disable-next-line: forin
    for (const p in obj1) {
      // Check property exists on both objects
      if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) { return false; }

      switch (typeof (obj1[p])) {
        // Deep compare objects
        case 'object':
          if (!this.deepCompare(obj1[p], obj2[p])) { return false; }
          break;
        // Compare function code
        case 'function':
          if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) { return false; }
          break;
        // Compare values
        default:
          if (obj1[p] != obj2[p]) { return false; }
      }
    }

    // Check object 2 for any extra properties
    for (const p in obj2) {
      if (typeof (obj1[p]) == 'undefined') { return false; }
    }
    return true;
  }

  flattenObject(data: any) {
    return data.map((value: any, key: any) => this.flattenOneObject(value));
  }

  flattenOneObject(ob: any) {
    if (typeof ob === 'string') {
      return ob;
    }
    const toReturn: any = {};
    for (const i in ob) {
      if (!ob.hasOwnProperty(i)) { continue; }
      // tslint:disable-next-line: triple-equals
      if ((typeof ob[i]) == 'object' && !(ob[i] instanceof Array)) {
        const flatObject = this.flattenOneObject(ob[i]);
        for (const x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) { continue; }
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  }

  deflattenObject(obj: any) {
    const type = typeof obj;
    const result = {};
    if (type == 'object' && !(obj instanceof Array)) {
      // tslint:disable-next-line: forin
      for (const i in obj) {
        const allKeys = i.split('.');
        // tslint:disable-next-line: prefer-const
        // tslint:disable-next-line: one-variable-per-declaration
        let temp: any = result, length = allKeys.length;
        const lastKey = allKeys[length - 1];
        allKeys.forEach((key, i) => {
          if (i < (length - 1)) {
            temp[key] = temp[key] || {};
            temp = temp[key];
          }
        });
        temp[lastKey] = obj[i];
      }
      return result;
    } else {
      return obj;
    }
  }

  clearEmptyFields(data: any, emptyFillWith?: any) {
    if (isEmptyField(emptyFillWith)) {
      emptyFillWith = null;
    }
    const returnableObject: any = {};
    let flattenData: any;
    let isObjectEmpty = true;
    if (Array.isArray(data)) {
      flattenData = this.flattenObject(data);
      flattenData.forEach((singleObject: any) => {
        [singleObject, isObjectEmpty] = this.clearOneObjectEmptyFields(singleObject, isObjectEmpty, emptyFillWith);
      });
    } else {
      flattenData = this.flattenOneObject(data);
      [flattenData, isObjectEmpty] = this.clearOneObjectEmptyFields(flattenData, isObjectEmpty, emptyFillWith);
    }
    const deflattenObject = this.deflattenObject(flattenData);
    returnableObject.data = deflattenObject;
    returnableObject.isObjectEmpty = isObjectEmpty;
    return deflattenObject;
  }

  clearOneObjectEmptyFields(flattenData: any, isObjectEmpty: any, emptyFillWith: any) {
    for (const val of Object.keys(flattenData)) {
      if (isNullOrUndefined(flattenData[val]) || flattenData[val] === '') {
        flattenData[val] = emptyFillWith;
      }
    }
    return [flattenData, isObjectEmpty];
  }

  checkOneObjectForEmpty(flattenData: any, isObjectEmpty: any) {
    for (const val of Object.keys(flattenData)) {
      if (isNullOrUndefined(flattenData[val]) || flattenData[val] === '') {
        flattenData[val] = null;
      } else {
        isObjectEmpty = false;
      }
    }
    return isObjectEmpty;
  }

  isEmptyEveryField(data: any) {
    let isObjectEmpty = true;
    let flattenData: any = {};
    if (Array.isArray(data)) {
      flattenData = this.flattenObject(data);
      flattenData.forEach((singleObject: any) => {
        if (!isObjectEmpty) {
          isObjectEmpty = this.checkOneObjectForEmpty(singleObject, isObjectEmpty);
        }
      });
    } else {
      flattenData = this.flattenOneObject(data);
      isObjectEmpty = this.checkOneObjectForEmpty(flattenData, isObjectEmpty);
    }
    return isObjectEmpty;
  }

  convertToIntegerFromArrayOfObjects(data: any[], fields: string[]) {
    data.forEach(element => {
      element = this.convertToIntegerFromObject(element, fields);
    });
    return data;
  }

  convertToIntegerFromObject(object: any, fields: string[]) {
    for (const key of Object.keys(object)) {
      if (fields.indexOf(key) != -1) {
        object[key] = parseFloat(object[key]);
      }
    }
    return object;
  }

}
